import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "optionCdPlayer"
const OptionCdPlayerIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m12 2c2.652 0 5.196 1.054 7.071 2.929s2.929 4.419 2.929 7.071c0 5.523-4.477 10-10 10-2.652 0-5.196-1.054-7.071-2.929s-2.929-4.419-2.929-7.071 1.054-5.196 2.929-7.071 4.419-2.929 7.071-2.929zm4 7v-2h-4v5.5c-.42-.31-.93-.5-1.5-.5-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5 2.5-1.119 2.5-2.5v-5.5z" />
    </svg>
  )
}
export default OptionCdPlayerIcon
